module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/doctor/doctor.component.scss
// module id = ./src/app/doctor/doctor.component.scss
// module chunks = main